import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { CATEGORY_KEY_TO_SLUG, formatMXN } from "@/lib/catalog";
import { UnitStatusBadge } from "./UnitStatusBadge";

export function UnitCard({ unit }) {
  const slug = CATEGORY_KEY_TO_SLUG[unit.category] || unit.category;
  const isPromo = unit.category === "promocion";
  return (
    <Link
      to={`/inventario/${slug}/${unit.id}`}
      className="group flex flex-col overflow-hidden rounded-sm border border-[#3E5641]/10 bg-white transition-colors hover:border-[#A0553F]"
      data-testid={`unit-card-${unit.id}`}
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-[#F1F3F3]">
        {!isPromo && unit.oferta_vigente && (
          <span className="absolute left-3 top-3 z-10 rounded-sm bg-[#C4674F] px-2.5 py-1 mono text-[11px] uppercase tracking-widest text-white shadow" data-testid={`unit-card-oferta-${unit.id}`}>Oferta</span>
        )}
        {unit.imagen_principal ? (
          <img
            src={fileUrl(unit.imagen_principal)}
            alt={unit.titulo}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            loading="lazy"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-xs text-[#6B7678]">Sin imagen</div>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            {!isPromo && (
              <p className="mono text-[10px] uppercase tracking-widest text-[#6B7678]">
                {unit.marca} · {unit.anio}
              </p>
            )}
            {isPromo && (
              <p className="mono text-[10px] uppercase tracking-widest text-[#A0553F]">
                Promoción
              </p>
            )}
            <h3 className="mt-1 font-serif text-xl leading-tight text-[#3E5641]">{unit.titulo}</h3>
          </div>
          <UnitStatusBadge estado={unit.estado} />
        </div>
        {isPromo ? (
          <p className="mt-auto text-xs text-[#6B7678]">
            {unit.vigencia_fin ? `Válida hasta ${formatDate(unit.vigencia_fin)}` : "Vigencia abierta"}
          </p>
        ) : unit.oferta_vigente && unit.oferta?.precio_oferta != null ? (
          <p className="mt-auto flex flex-wrap items-baseline gap-2" data-testid={`unit-card-precio-${unit.id}`}>
            <span className="mono text-lg text-[#C4674F]">{formatMXN(unit.oferta.precio_oferta)}</span>
            <span className="mono text-xs text-[#6B7678] line-through">{formatMXN(unit.oferta.precio_lista ?? unit.precio)}</span>
          </p>
        ) : (
          <p className="mt-auto mono text-lg text-[#3E5641]">{formatMXN(unit.precio)}</p>
        )}
      </div>
    </Link>
  );
}

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}
